import { render, staticRenderFns } from "./DepositContent.vue?vue&type=template&id=151a0284&"
import script from "./DepositContent.vue?vue&type=script&lang=ts&"
export * from "./DepositContent.vue?vue&type=script&lang=ts&"
import style0 from "./DepositContent.vue?vue&type=style&index=0&id=151a0284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports